import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import TableLoader from '@/components/table-loader/TableLoader';

import type { Action } from '@/interfaces/app.interfaces';

import * as styles from './PendingActionsTable.css';

type Props = {
  columns: any[];
  data: Action[] | undefined;
  isLoading: boolean;
  isRefetching: boolean;
};

export default function PendingActionsTable({ columns, data, isLoading, isRefetching }: Props) {
  const { t } = useTranslation();

  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        {isLoading && !data ? (
          <TableLoader />
        ) : (
          <TradingDatagrid
            tableHeight="calc(40vh - 100px)"
            columnsTable={columns}
            stickyColumns={{
              approve: 'right',
              reject: 'right',
            }}
            dataTable={data}
            flexLayout
            keepSelectedRowsOnPageChange={false}
            columnOrder={columns.map((column) => column.accessor)}
            isLoadingMore={isRefetching}
            noDataMessage={isRefetching ? '' : t('settings.moeveActionsTab.pendingActions.emptyMessage')}
          />
        )}
      </div>
    </TradingPanel>
  );
}
